// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__LYrBt","rotate":"Loader_rotate__JGNmM"};